module.exports = __webpack_public_path__ + "img/ax.a17e4b22.svg";